module.exports = __webpack_public_path__ + "img/index.953eac6b.png";